import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function Storage(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          d="M22.8588 5.18224L7.54844 14.8595C7.38046 14.9657 7.24209 15.1126 7.14619 15.2867C7.0503 15.4607 7.00001 15.6562 7 15.8549V42.7283H13.0642V22.2033H34.2112V42.7284H40.2754V15.8615C40.2755 15.6611 40.2243 15.464 40.1269 15.2889C40.0295 15.1138 39.8889 14.9664 39.7187 14.8608L24.1088 5.17689C23.921 5.06036 23.7041 4.99907 23.4831 5.00001C23.262 5.00096 23.0457 5.06411 22.8588 5.18224Z"
          fill="#4383CC"
        />
        <path
          d="M27.2352 19.0548H20.041C19.9022 19.0547 19.7691 18.9996 19.6709 18.9014C19.5728 18.8032 19.5176 18.6701 19.5176 18.5313V16.6938C19.5176 16.4047 19.752 16.1703 20.041 16.1703H27.2352C27.5243 16.1703 27.7587 16.4047 27.7587 16.6938V18.5313C27.7587 18.8204 27.5243 19.0548 27.2352 19.0548Z"
          fill="#D4E3F3"
        />
        <path
          d="M7 40.0073H13.0642V42.7283H7V40.0073ZM34.2112 40.0073H40.2754V42.7283H34.2112V40.0073Z"
          fill="#0E4686"
        />
        <rect x="16.6377" y="35.8642" width="7" height="6" fill="#A1C1E6" />
        <rect x="24.6377" y="35.8642" width="7" height="6" fill="#A1C1E6" />
        <rect x="20.6377" y="29.8642" width="7" height="5" fill="#A1C1E6" />
      </svg>
    </IconContainer>
  )
}
